import { Suspense } from "react";
import { Navigate } from "react-router-dom";

import { useFeature } from "~hooks/useFeature";
import { Route } from "~services/router/Route";

import LoadingIndicatorFullPage from "../../../cc-ui/components/LoadingIndicator/LoadingIndicatorFullPage";
import { PublicDirectoryPageAsync } from "./PublicDirectoryPageAsync";

/** Renders PublicDirectoryPage when publicPages feature is on; redirects to home when off. */
export function PublicDirectoryPageRoute() {
  const publicPagesEnabled = useFeature("publicPages");
  if (!publicPagesEnabled) {
    return <Navigate to={Route.home()} replace />;
  }
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <PublicDirectoryPageAsync />
    </Suspense>
  );
}
